import { useActiveMembership } from '@/features/session/useActiveMembership';
import { LegacyPricingBanner } from './LegacyPricingBanner';
import { PricingPageV2 } from './pricing-v2/PricingPageV2';

export function PricingPage() {
  const { membership } = useActiveMembership();
  const workspaceId = membership?.workspaceId ?? null;

  return (
    <>
      <LegacyPricingBanner workspaceId={workspaceId} />
      <PricingPageV2 workspaceId={workspaceId} />
    </>
  );
}
